/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_HeadingInputs */

const en_newsletter_heading = /** @type {(inputs: Newsletter_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to our newsletter`)
};

/**
* | output |
* | --- |
* | "Subscribe to our newsletter" |
*
* @param {Newsletter_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_heading = /** @type {((inputs?: Newsletter_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_heading(inputs)
});